module.exports = __webpack_public_path__ + "models/bgm.01438f7.txt";